import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import { AuthProvider } from "./lib/auth";
import { SettingsProvider } from "./lib/settings";
import { LiveEditProvider } from "./lib/liveEdit";
import { Toaster } from "./components/ui/toaster";

import PublicLayout from "./components/PublicLayout";
import SEOHead from "./components/SEOHead";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import CoursesPage, { CourseDetailPage } from "./pages/CoursesPage";
import EarnWhileYouLearnPage from "./pages/EarnWhileYouLearnPage";
import FacultyPage from "./pages/FacultyPage";
import NewsPage from "./pages/NewsPage";
import FinancialAidPage from "./pages/FinancialAidPage";
import PlacementPage from "./pages/PlacementPage";
import AdmissionsPage from "./pages/AdmissionsPage";
import ContactPage from "./pages/ContactPage";
import PartnersPage from "./pages/PartnersPage";
import CertificationsPage from "./pages/CertificationsPage";
import BlogPage, { BlogDetailPage } from "./pages/BlogPage";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import {
  ManageCourses, ManageBanners, ManageFaculty, ManageNews,
  ManageTestimonials, ManagePartners, ManageFinancialAid,
  ManageVideos, ManageInstagram, ManageTicker, ManageBlog,
} from "./pages/admin/ManagePages";
import ContactInbox from "./pages/admin/ContactInbox";
import AdmissionsInbox from "./pages/admin/AdmissionsInbox";
import ChatLeadsInbox from "./pages/admin/ChatLeadsInbox";
import SEOSettings from "./pages/admin/SEOSettings";
import AdminAccount from "./pages/admin/AdminAccount";

const Public = ({ children, slug }) => (
  <PublicLayout>
    <SEOHead slug={slug} />
    {children}
  </PublicLayout>
);

function App() {
  return (
    <HelmetProvider>
      <SettingsProvider>
        <AuthProvider>
         <LiveEditProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                {/* Public site */}
                <Route path="/" element={<Public slug="home"><Home /></Public>} />
                <Route path="/about" element={<Public slug="about"><AboutPage /></Public>} />
                <Route path="/about/partners" element={<Public slug="partners"><PartnersPage /></Public>} />
                <Route path="/about/certifications" element={<Public slug="certifications"><CertificationsPage /></Public>} />
                <Route path="/courses" element={<Public slug="courses"><CoursesPage /></Public>} />
                <Route path="/courses/earn-while-you-learn" element={<Public slug="earn-while-you-learn"><EarnWhileYouLearnPage /></Public>} />
                <Route path="/courses/detail/:slug" element={<Public slug="courses"><CourseDetailPage /></Public>} />
                <Route path="/courses/:category" element={<Public slug="courses"><CoursesPage /></Public>} />
                <Route path="/faculty" element={<Public slug="faculty"><FacultyPage /></Public>} />
                <Route path="/news" element={<Public slug="news"><NewsPage /></Public>} />
                <Route path="/financial-aid" element={<Public slug="financial-aid"><FinancialAidPage /></Public>} />
                <Route path="/placement" element={<Public slug="placement"><PlacementPage /></Public>} />
                <Route path="/admissions" element={<Public slug="admissions"><AdmissionsPage /></Public>} />
                <Route path="/contact" element={<Public slug="contact"><ContactPage /></Public>} />
                <Route path="/blog" element={<Public slug="blog"><BlogPage /></Public>} />
                <Route path="/blog/:slug" element={<Public slug="blog"><BlogDetailPage /></Public>} />

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="seo" element={<SEOSettings />} />
                  <Route path="courses" element={<ManageCourses />} />
                  <Route path="banners" element={<ManageBanners />} />
                  <Route path="blog" element={<ManageBlog />} />
                  <Route path="ticker" element={<ManageTicker />} />
                  <Route path="videos" element={<ManageVideos />} />
                  <Route path="instagram" element={<ManageInstagram />} />
                  <Route path="faculty" element={<ManageFaculty />} />
                  <Route path="news" element={<ManageNews />} />
                  <Route path="testimonials" element={<ManageTestimonials />} />
                  <Route path="partners" element={<ManagePartners />} />
                  <Route path="financial-aid" element={<ManageFinancialAid />} />
                  <Route path="contacts" element={<ContactInbox />} />
                  <Route path="admissions" element={<AdmissionsInbox />} />
                  <Route path="chat-leads" element={<ChatLeadsInbox />} />
                  <Route path="account" element={<AdminAccount />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster />
          </div>
         </LiveEditProvider>
        </AuthProvider>
      </SettingsProvider>
    </HelmetProvider>
  );
}

export default App;
